/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보결과\관심표명자 수정 버튼
 * 버전 : 1.0
 * 파일명 : ButtonResultModifynterest.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2026-02-02, 강동형 : 학과 추가
 *================================================================= */

import React, { useEffect } from 'react'
import { NextButton } from '../common/CommonStyled'
import { usePromoAddInterest } from 'src/stores/PromoStore'
import { format } from 'date-fns'
import { PromoResultType } from 'src/pages/PromoResultPage';
import { patchInterested } from 'src/api/Interested'

interface Props{
  setTab : React.Dispatch<React.SetStateAction<PromoResultType>>;
}

const ButtonResultModifynterest = ({setTab}:Props) => {
    const recent_date = usePromoAddInterest((state)=>state.recent_date)
    const name = usePromoAddInterest((state)=>state.name)
    const phone = usePromoAddInterest((state)=>state.phone)
    const birth_date = usePromoAddInterest((state)=>state.birth_date)
    const gender = usePromoAddInterest((state)=>state.gender)
    const memo = usePromoAddInterest((state)=>state.memo)
    const interestData = usePromoAddInterest((state)=>state.interestData)
    const school_class = usePromoAddInterest((state)=>state.school_class)
    const type = usePromoAddInterest((state)=>state.type)
    const major = usePromoAddInterest((state)=>state.major)

    const reset = usePromoAddInterest((state)=>state.reset)

    useEffect(()=>{
      return()=>{
        reset()
      }
    },[])

    const handleResultAdd = async()=>{
        
        const fromat_date = format(recent_date, 'yyyy-MM-dd');
        const fromat_date2 = format(birth_date, 'yyyy-MM-dd');
        await patchInterested(
            {row_id : interestData.id,
            input_date : fromat_date,
            name : name,
            birthday : fromat_date2,
            gender : gender,
            phone : phone,
            status : type,
            memo: memo, 
            school_class,
            major_name: major
        }
        )
        setTab('detail')
    }

  return (
    <NextButton onClick={()=>handleResultAdd()}>적용</NextButton>
  )
}

export default ButtonResultModifynterest